import Box from "@mui/material/Box";
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import ListItemText from "@mui/material/ListItemText";
import Divider from "@mui/material/Divider";
import Typography from "@mui/material/Typography";
import Accordion from "@mui/material/Accordion";
import AccordionDetails from "@mui/material/AccordionDetails";
import AccordionSummary from "@mui/material/AccordionSummary";
import { useDispatch, useSelector } from "react-redux";
import { StyledMobileSidebarTopBox } from "@Styled/Layout/header";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { useRouter } from "next/router";
import { CartActions } from "@Redux-Store/Actions/CartActions";
import { CategoryHierarchy } from "@Interfaces/Api/category";
import { MouseEventHandler, useEffect, useState } from "react";
import { StyledHorizontalDivider } from "@Styled/Common";
import { apiUser } from "@Services/API/IndividualApi's/User";
import Cookies from "js-cookie";

interface listMenuItem {
  id: string | number;
  name: string;
  onClickHanlder?: MouseEventHandler<HTMLDivElement> | undefined;
  subMenu?: listMenuItem[];
  dividerTop?: boolean;
  dividerBottom?: boolean;
}

export default function MobileSideDrawerContent({
  toggleDrawer,
  categoryHierarchy,
}: {
  toggleDrawer: Function;
  categoryHierarchy: CategoryHierarchy[];
}) {
  const [categoryMenuDetails, setCategoryMenuDetails] = useState<
    listMenuItem[]
  >([]);
  const changeRoute = (url: string) => () => {
    router.replace(url);
    toggleDrawer(false)();
  };

  const userId = Cookies.get("userId");

  const handleLogout = async () => {
    const obj = {};
    try {
      const response = await apiUser.logout(obj);
      window.location.reload();
      dispatch(CartActions.ClearCart());
      router.push("/");
      toggleDrawer(false)();
    } catch (err) { }
  };

  const handleLogin = () => {
    router.push("/login");
  };

  useEffect(() => {
    const arr: listMenuItem[] = [];
    categoryHierarchy.map((item) => {
      const obj: listMenuItem = {
        id: item._id,
        name: item.name,
        onClickHanlder: changeRoute(`/collections/${item.slug}`),
      };
      if (item.childCategories && item.childCategories.length > 0) {
        const childArr: listMenuItem[] = [];
        item.childCategories.map((val) => {
          const obj: listMenuItem = {
            id: val._id,
            name: val.name,
            onClickHanlder: changeRoute(`/collections/${item.slug}/${val.slug}`),
          };
          childArr.push(obj);
        });
        obj["subMenu"] = childArr;
      }
      arr.push(obj);
    });
    setCategoryMenuDetails(arr);
  }, [categoryHierarchy]);
  const dispatch = useDispatch();
  const menuList: listMenuItem[] = userId
    ? [
      {
        id: 1,
        name: "Home",
        onClickHanlder: changeRoute("/"),
        dividerBottom: true,
      },
      ...categoryMenuDetails,
      {
        id: 3,
        name: "My Orders",
        onClickHanlder: changeRoute("/my-orders"),
        dividerTop: true,
        dividerBottom: true,
      },
      {
        id: 2,
        name: "My Account",
        subMenu: [
          {
            id: 4,
            name: "My Profile",
            onClickHanlder: changeRoute("/my-profile"),
          },
        ],

        dividerBottom: true,
      },
      {
        id: 5,
        name: "Logout",
        onClickHanlder: handleLogout,
      },
    ]
    : [
      {
        id: 1,
        name: "Home",
        onClickHanlder: changeRoute("/"),
        dividerBottom: true,
      },
      ...categoryMenuDetails,
      {
        id: 3,
        name: "Blogs",
        onClickHanlder: changeRoute("/blogs"),
        dividerTop: true,
      },
      {
        id: 2,
        name: "Login",
        onClickHanlder: handleLogin,
        dividerTop: true,
      },
    ];

  const router = useRouter();

  const user = useSelector((state) => state.UserReducer.user);
  return (
    <Box
      role="presentation"
      // onClick={toggleDrawer(false)}
      onKeyDown={toggleDrawer(false)}
      sx={{ width: "60vw" }}
    >
      <StyledMobileSidebarTopBox>
        <Typography sx={{ fontSize: "1.2rem" }}>
          Hello, {user ? user.name : "User"}
        </Typography>
        {/* <Typography sx={{ fontSize: "1.2rem" }}>Your Account</Typography> */}
      </StyledMobileSidebarTopBox>
      <List sx={{ marginTop: "1rem" }}>
        {menuList.map((item) => (
          <>
            {item.subMenu ? (
              <>
                {item.dividerTop && <StyledHorizontalDivider />}
                <ListItem button key={item.id}>
                  <Accordion
                    sx={{
                      boxShadow: "none",
                      width: "100%",
                      padding: 0,
                      minHeight: 0,
                    }}
                  >
                    <AccordionSummary
                      expandIcon={<ExpandMoreIcon />}
                      aria-controls="panel1a-content"
                      id="panel1a-header"
                      style={{
                        padding: 0,
                        minHeight: 0,
                      }}
                    >
                      <Typography
                        style={{
                          margin: "0px",
                          fontSize: "0.9rem",
                          textTransform: "capitalize",
                        }}
                      >
                        {item.name}
                      </Typography>
                    </AccordionSummary>
                    {item.subMenu.map((item) => (
                      <AccordionDetails
                        onClick={item.onClickHanlder!}
                        key={item.id}
                      >
                        {/* <Link href={item.href}> */}
                        <Typography
                          style={{
                            fontSize: "0.9rem",
                            textTransform: "capitalize",
                            margin: "0px !important",
                          }}
                        >
                          {item.name}
                        </Typography>
                        {/* </Link> */}
                      </AccordionDetails>
                    ))}
                  </Accordion>
                </ListItem>
                {item.dividerBottom && <StyledHorizontalDivider />}
              </>
            ) : (
              <>
                {item.dividerTop && <StyledHorizontalDivider />}
                <ListItem button key={item.id}>
                  <ListItemText
                    onClick={item.onClickHanlder!}
                    primary={item.name}
                    primaryTypographyProps={{
                      sx: { fontSize: "0.9rem", textTransform: "capitalize" },
                    }}
                  />
                </ListItem>
                {item.dividerBottom && <StyledHorizontalDivider />}
              </>
            )}
          </>
        ))}
      </List>
      <Divider />
    </Box>
  );
}
